import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=6e5b9b74"
import script from "./frame.vue?vue&type=script&lang=js"
export * from "./frame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports